import { Location, LocationArray, LocationObject } from '@Types/stations.types';

export function parseLocationToString(location?: Location): string {
	if (location) {
		if (typeof location === 'object' && !Array.isArray(location)) {
			const { latitude, longitude } = location;
			return `${latitude}, ${longitude}`;
		}
		if (Array.isArray(location)) {
			const [longitude, latitude] = location;
			if (latitude && longitude) {
				return `${latitude}, ${longitude}`;
			}
		}
	}
	return '';
}

const isLocationValid = (latitude: number, longitude: number) => {
	if (
		latitude >= -90 &&
		latitude <= 90 &&
		longitude >= -180 &&
		longitude <= 180
	)
		return true;
	return false;
};

const parseLocationString = (location: string) => {
	const locationArray = location.split(',').map(value => value.trim());
	if (locationArray.length === 2) {
		const latitude = Number(locationArray[0]);
		const longitude = Number(locationArray[1]);
		if (
			!isNaN(latitude) &&
			!isNaN(longitude) &&
			isLocationValid(latitude, longitude)
		)
			return {
				latitude,
				longitude,
			};
	}
};

//used by API
export const parseLocationToObject = (
	location?: string,
): LocationObject | undefined => {
	if (location) {
		return parseLocationString(location);
	}
};

//used by Map
export const parseLocationToArray = (
	location?: string,
): LocationArray | undefined => {
	if (location) {
		const locationObject = parseLocationString(location);
		if (locationObject)
			return [locationObject.longitude, locationObject.latitude];
	}
};
